import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { signInWithEmailAndPassword, updatePassword } from '@firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class PasswordChangeService {
  public errorMessages: string[] = [];
  
  constructor(private app: AppService) {
  }

  get user() {
    return this.app.firebaseAuth.currentUser?.email;
  }

  get isLoggedIn() {
    return this.app.firebaseAuth.currentUser != null;
  }

  changePassword(oldpass: string, newpass: string) {
    if (this.user) {
      signInWithEmailAndPassword(this.app.firebaseAuth, this.user, oldpass)
      .then (() => {
        if (this.app.firebaseAuth.currentUser) {
          updatePassword(this.app.firebaseAuth.currentUser, newpass)
          .catch (() => {
            this.errorMessages = [];
            this.errorMessages.push('Password update failed');
          });
        } else {
          this.errorMessages = [];
          this.errorMessages.push('Password update failed. Current user not found');
      }
      })
      .catch (() => {
        this.errorMessages = [];
        this.errorMessages.push('Old Password not valid');
      });
    }
  }

  isAuthorized() {
    return this.user != null;
  }
}
